/* Yumi & Cie — utilitaires d'interface (v6.11)
   1. Carrousels [data-yc-glide] : flèches fiables (cible cumulée : les clics
      rapides s'additionnent au lieu d'être avalés pendant l'animation),
      boucle aux extrémités, mélange optionnel data-yc-shuffle.
   2. Copie de code promo [data-yc-copy] : clic → presse-papier → « Copié ! ».
   3. Newsletter : quand la page anti-robot /challenge s'intercale, Shopify
      revient sur « /#<id-du-formulaire> » SANS customer_posted=true — le
      fragment sert donc de signal : on affiche le code quand même, puis on
      recentre la carte entière (fini le saut d'ancre à mi-carte). */
(function () {
  'use strict';

  /* ---------- carrousels ---------- */
  function initGlide(wrap) {
    if (wrap.dataset.ycInit) return;
    wrap.dataset.ycInit = '1';
    var track = wrap.querySelector(wrap.dataset.ycTrack || '.yc-carousel__track');
    var prev = wrap.querySelector('[data-yc-prev]');
    var next = wrap.querySelector('[data-yc-next]');
    if (!track) return;

    if (wrap.dataset.ycShuffle === '1') {
      var cards = Array.prototype.slice.call(track.children);
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = cards[i];
        cards[i] = cards[j];
        cards[j] = tmp;
      }
      cards.forEach(function (c) { track.appendChild(c); });
    }
    if (!prev || !next) return;

    var target = null; /* position visée pendant une animation, sinon null */
    var idle;
    var maxScroll = function () { return Math.max(0, track.scrollWidth - track.clientWidth); };
    var step = function () { return Math.max(track.clientWidth - 80, 240); };
    var go = function (dir) {
      var max = maxScroll();
      if (max <= 0) return;
      var base = target === null ? track.scrollLeft : target;
      var t = base + dir * step();
      if (t > max + 4) {
        t = base >= max - 4 ? 0 : max; /* déjà au bout → on boucle au début */
      } else if (t < -4) {
        t = base <= 4 ? max : 0; /* déjà au début → on boucle à la fin */
      }
      t = Math.max(0, Math.min(max, t));
      target = t;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: t, behavior: reduce ? 'auto' : 'smooth' });
    };
    track.addEventListener('scroll', function () {
      clearTimeout(idle);
      idle = setTimeout(function () { target = null; }, 140);
    }, { passive: true });
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    /* CLICS MORTS. `go()` sort immediatement quand le rail ne deborde pas
       (max <= 0), mais les fleches restaient affichees : on cliquait, rien ne
       bougeait. Mesure du 01/08 sur l'accueil a 1440 px : sur six fleches,
       quatre etaient dans ce cas — le carrousel de rayons et la deuxieme bande
       de produits tiennent en entier a cette largeur. C'est exactement ce que
       le client decrivait.

       On efface donc les fleches quand il n'y a rien a faire defiler, et on
       reevalue a chaque changement de taille : une meme page passe d'un etat a
       l'autre quand on redimensionne la fenetre.

       ATTENTION : `.yc-arrow` a `display: flex`, qui l'emporte sur le
       `display: none` que le navigateur applique a [hidden]. La regle
       `.yc-arrow[hidden] { display: none !important }` est indispensable, elle
       vit dans yumi-v3.css. */
    var majFleches = function () {
      var utile = maxScroll() > 2;
      [prev, next].forEach(function (b) {
        b.hidden = !utile;
        b.disabled = !utile;
        b.setAttribute('aria-hidden', utile ? 'false' : 'true');
        b.tabIndex = utile ? 0 : -1;
      });
    };
    majFleches();
    if (window.ResizeObserver) {
      new window.ResizeObserver(majFleches).observe(track);
    } else {
      window.addEventListener('resize', majFleches);
    }
    /* Les images arrivent apres : la largeur du rail change une fois qu'elles
       sont posees. On repasse donc au chargement complet. */
    window.addEventListener('load', majFleches);
  }

  function boot() {
    document.querySelectorAll('[data-yc-glide]').forEach(initGlide);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); newsBoot(); });
  } else {
    boot();
    newsBoot();
  }
  document.addEventListener('shopify:section:load', boot);

  /* ---------- newsletter : état « inscrit » même après le captcha ----------
     Après la page /challenge, Shopify revient sur « /#<id-du-formulaire> »
     SANS le paramètre customer_posted=true. Ce fragment n'est produit que
     par une soumission réussie : c'est LUI le signal fiable (l'événement
     submit, lui, est court-circuité par l'anti-robot de Shopify qui
     re-soumet le formulaire par form.submit(), sans événement DOM). */
  function newsBoot() {
    var posted = /[?&]customer_posted=true/.test(location.search);
    var forms = Array.prototype.slice.call(document.querySelectorAll('form.yc-news__formwrap'));
    if (!forms.length) return;
    var hashForm = null;
    var hashId = location.hash ? location.hash.slice(1) : '';
    if (hashId) {
      forms.forEach(function (f) { if (f.id === hashId) hashForm = f; });
    }
    if (!posted && !hashForm) return;
    if (!posted) {
      /* retour du challenge sans confirmation serveur : on affiche le bloc
         succès embarqué dans un <template>, sauf si une erreur est affichée */
      if (document.querySelector('.yc-news__error')) return;
      forms.forEach(function (f) {
        var tpl = f.querySelector('template[data-yc-news-tpl]');
        if (tpl && tpl.content && tpl.content.childElementCount) {
          f.innerHTML = '';
          f.appendChild(tpl.content.cloneNode(true));
        }
      });
    }
    var card = hashForm ? hashForm.closest('.yc-news') : null;
    if (!card || !card.offsetWidth) {
      for (var i = 0; i < forms.length; i++) {
        var c = forms[i].closest('.yc-news');
        if (c && c.offsetWidth) { card = c; break; }
      }
    }
    if (card) {
      /* remplace le saut d'ancre natif (qui calait le haut du formulaire et
         coupait la mascotte) par un centrage de la carte entière */
      setTimeout(function () {
        card.scrollIntoView({ block: 'center', behavior: 'auto' });
      }, 60);
    }
  }

  /* ---------- copie de code promo ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yc-copy]');
    if (!btn || btn.dataset.ycBusy) return;
    var code = btn.dataset.ycCopy;
    var done = function () {
      btn.dataset.ycBusy = '1';
      var old = btn.innerHTML; /* le bouton contient l'icône SVG « copier » */
      btn.innerHTML = '✓ Copié !';
      btn.classList.add('yc-copied');
      setTimeout(function () {
        btn.innerHTML = old;
        btn.classList.remove('yc-copied');
        delete btn.dataset.ycBusy;
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) { /* tant pis */ }
      document.body.removeChild(ta);
      done();
    }
  });
})();
